import { openBlock as t, createElementBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function h(l, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M14.537 4.667h-.648V3.333h-1.296v1.334H7.407V3.333H6.111v1.334h-.648c-.72 0-1.29.6-1.29 1.333l-.006 9.333c0 .354.136.693.38.943.242.25.572.39.916.39h9.074c.713 0 1.296-.6 1.296-1.333V6c0-.733-.583-1.333-1.296-1.333m0 10.666H5.463V8.667h9.074zm-6.481-4H6.759V10h1.297zm2.592 0H9.352V10h1.296zm2.593 0h-1.297V10h1.297zM8.056 14H6.759v-1.333h1.297zm2.592 0H9.352v-1.333h1.296zm2.593 0h-1.297v-1.333h1.297z"
    }, null, -1)
  ])]);
}
const m = { render: h };
export {
  m as default,
  h as render
};
